export default function PHP_easter_date() {
  return (
    <div>
      <h1>PHP_easter_date</h1>
    </div>
  );
}
